import ACTIONS from "./types.actions";
import appInitialState from "../app-state/app-initial.state";

export function setLanguage(language = appInitialState.language) {
  return { type: ACTIONS.SET_LANGUAGE, language };
}
